export function calculateRem (pixels) {
  const rem = `${ pixels / 16 }rem`
  return rem
}
